import { Duration } from 'luxon';

export const TELEMATICS_OFFLINE_THRESHOLD = Duration.fromObject({
  minutes: 60,
});
